import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

// ------------------ list SO-------
const getAllSO = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.so.list + `${filter ? '?' + filter : ''}`);
    return data;
};

const GetAllSOQuery = (filter) => {
    return useQuery(['SOlist', filter], () => getAllSO(filter));
};

// ------------------ Add SO-------
const addSO = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.so.add, payload);
};

const AddSOMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addSO, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('SOlist');
            toastMessage('success', 'Sale Order Created Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            toastMessage('error', desc || 'Server Error');
        }
    });
};

export { AddSOMutation, GetAllSOQuery };
